import { api } from "api/api";
import { AxiosError } from "axios";
import ItemInspecaoFrota from "model/gestao/frotas/ItemInspecaoFrota";
import Page from "model/page/Page";
import Pageable from "model/page/Pageable";
import { DataTableFilterMeta } from "primereact/datatable";
import { BaseServiceCadastros } from "service/BaseServiceCadastros";
import { getFilters } from "utils/filterUtils";

class ItemInspecaoFrotaService implements BaseServiceCadastros<ItemInspecaoFrota> {

    pesquisar(page: Pageable, filters?: DataTableFilterMeta | null) {
        return new Promise<Page>((resolve, reject): void => {
            let url = `/itemInspecaoFrota/pesquisar`;
            url += getFilters(filters);
            
            const params = {
                page: page.page,
                size: page.size,
                sort: page.sort,
            };
            
            api
                .get(url, { params })
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    consultar(id: number) {
        return new Promise<ItemInspecaoFrota>((resolve, reject): void => {
            api
                .get(`/itemInspecaoFrota/consultar/${id}`)
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    incluir(itemInspecaoFrota: ItemInspecaoFrota) {
        return new Promise<ItemInspecaoFrota>((resolve, reject): void => {
            api
                .post(`/itemInspecaoFrota/incluir`, JSON.stringify(itemInspecaoFrota))
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    editar(itemInspecaoFrota: ItemInspecaoFrota) {
        return new Promise<ItemInspecaoFrota>((resolve, reject): void => {
            api
                .put(`/itemInspecaoFrota/editar`, JSON.stringify(itemInspecaoFrota))
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    excluir(id: number) {
        return new Promise<void>((resolve, reject): void => {
            api
                .delete(`/itemInspecaoFrota/excluir/${id}`)
                .then(() => resolve())
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    getPeriodicidadeLista(){
        return [{
            value: 'DIAS',
            label: 'Dias'
        },
        {
            value: 'MESES',
            label: 'Meses'
        },
        {
            value: 'ANOS',
            label: 'Anos'
        }]
    }

    getPeriodicidade(periodicidade: string): string{
        let periodicidadeObj = this.getPeriodicidadeLista().find((item) => item.value === periodicidade)
        if(periodicidadeObj){
            return periodicidadeObj.label
        }
        return "";
    }

}

export default ItemInspecaoFrotaService;